import type { Pose, ProgressStatus } from '../types';
import { tierLabel } from '../data/poses';
import { PoseMedia } from './PoseMedia';

interface Props {
  pose: Pose;
  status: ProgressStatus;
}

export function PoseCard({ pose, status }: Props) {
  return (
    <a className="card card-link" href={`#/pose/${pose.id}`}>
      {/* Name + Sanskrit are rendered into the image art itself, so the card
          body intentionally omits them to avoid duplication. */}
      <PoseMedia pose={pose} />
      <div className="card-body">
        <div className="meta">
          <span className="chip">{pose.category}</span>
          <span className={`chip level tier-${pose.difficultyTier}`}>
            {tierLabel(pose.difficultyTier)}
          </span>
          {pose.hold && <span className="chip hold">{pose.hold}</span>}
          {pose.sanskritFromSource === false && (
            <span className="chip flag">not in source</span>
          )}
          {status !== 'new' && <span className={`status-pill ${status}`}>{status}</span>}
        </div>
        <p className="desc">{pose.description}</p>
      </div>
    </a>
  );
}
